var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7523 24.1852C40.7523 29.7261 37.0286 34.0556 32.6181 34.0556C28.2076 34.0556 24.4839 29.7261 24.4839 24.1852C24.4839 18.6443 28.2076 14.3148 32.6181 14.3148C37.0286 14.3148 40.7523 18.6443 40.7523 24.1852Z",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3713 39.0186H38.8241C48.1991 39.0186 55.8302 46.4853 56.0948 55.7963H10.1006C10.3652 46.4853 17.9963 39.0186 27.3713 39.0186Z",
    stroke: "#103B5D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.6587,
    y1: 39.5062,
    x2: 32.6587,
    y2: 55.3087,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37.4553,
    y1: 39.5062,
    x2: 37.4553,
    y2: 55.3087,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42.2522,
    y1: 39.5062,
    x2: 42.2522,
    y2: 55.3087,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.8618,
    y1: 39.5062,
    x2: 27.8618,
    y2: 55.3087,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 23.0649,
    y1: 39.5062,
    x2: 23.0649,
    y2: 55.3087,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2683,
    y1: 41.4814,
    x2: 18.2683,
    y2: 55.3086,
    stroke: "#103B5D",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9309,
    y1: 45.4321,
    x2: 13.9309,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 47.5083,
    y1: 41.4814,
    x2: 47.5083,
    y2: 55.3086,
    stroke: "#103B5D"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 52.3052,
    y1: 45.4321,
    x2: 52.3052,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 12.9717,
    y1: 46.4198,
    x2: 12.9717,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 46.5488,
    y1: 40.4938,
    x2: 46.5488,
    y2: 55.3086,
    stroke: "#103B5D"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3457,
    y1: 44.4445,
    x2: 51.3457,
    y2: 55.3087,
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.162 43.5921L52.2397 38.8797L53.3167 40.5429L57.0863 38.3253L56.0093 36.6621L69.472 28.6234L72.1646 33.613L57.894 46.6413L59.2403 50.522V53.8484L57.894 57.452L55.4708 60.5011L52.2397 61.8871L48.7394 62.4415L44.9698 61.3327L42.2773 59.3923L40.1232 56.066L39.5847 53.0168L40.1232 49.136L41.4695 46.0869L44.162 43.5921Z",
    fill: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0758 46.2295C42.8509 48.1464 41.7453 52.4069 43.6072 55.7269C45.4691 59.0469 49.6098 60.1891 52.8308 58.2746C56.0557 56.3578 57.1613 52.0973 55.2994 48.7773C53.4352 45.4533 49.2968 44.3151 46.0758 46.2295ZM52.2956 57.3203C49.577 58.9362 46.0915 57.9713 44.5241 55.1765C42.9546 52.3778 43.8879 48.7917 46.6065 47.1758C49.3251 45.56 52.8106 46.5249 54.3779 49.3196C55.9475 52.1184 55.0103 55.7068 52.2956 57.3203Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8738 28.4009C69.7276 28.1402 69.402 28.0504 69.1488 28.2009L55.7196 36.183C55.4665 36.3334 55.3792 36.6687 55.5254 36.9293L56.3124 38.3327L53.59 39.9508L52.8029 38.5475C52.6568 38.2868 52.3312 38.197 52.078 38.3475L44.2612 42.9937C39.307 45.9383 37.6094 52.4861 40.4719 57.5904C41.8459 60.0403 44.0881 61.7977 46.7851 62.5416C49.4798 63.2816 52.2612 62.9168 54.6254 61.5116C54.6293 61.5093 54.6371 61.5047 54.641 61.5023C57.034 60.0746 58.7895 57.6305 59.4567 54.8013C60.1074 52.0355 59.7125 49.2015 58.3437 46.7699L72.5697 34.0693C72.7631 33.8956 72.8087 33.6065 72.6828 33.382L69.8738 28.4009ZM57.3055 46.2429C57.1044 46.4213 57.0655 46.7224 57.2037 46.9503C58.6092 49.2157 59.0403 51.9106 58.4219 54.5396C57.8128 57.1204 56.2791 59.2563 54.1041 60.5544C54.1002 60.5567 54.0924 60.5613 54.0886 60.5636C51.9698 61.823 49.4744 62.1514 47.0539 61.4837C44.6356 60.82 42.6195 59.2437 41.3872 57.0464C38.817 52.4633 40.3462 46.5877 44.7902 43.9463L52.1436 39.5756L52.9306 40.979C53.0767 41.2396 53.4023 41.3294 53.6555 41.1789L57.301 39.0121C57.5542 38.8616 57.6414 38.5264 57.4953 38.2658L56.7082 36.8624L69.2222 29.4244L71.5393 33.5377L57.3055 46.2429Z",
    fill: "#103B5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1533 29.8265L52.2002 35.2596C52.3464 35.5202 52.672 35.61 52.9252 35.4596C53.1783 35.3091 53.2656 34.9739 53.1194 34.7132L50.0725 29.2801C49.9263 29.0195 49.6007 28.9297 49.3476 29.0802C49.0921 29.2266 49.0049 29.5618 49.1533 29.8265Z",
    fill: "#103B5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1885 33.3593C45.0407 33.6236 45.1286 33.9563 45.3831 34.1044L50.6475 37.2411C50.8186 37.3426 51.0216 37.3342 51.1774 37.2416C51.2553 37.1953 51.322 37.1289 51.3712 37.0408C51.519 36.7766 51.4311 36.4439 51.1767 36.2957L45.9123 33.159C45.6617 33.0085 45.3386 33.099 45.1885 33.3593Z",
    fill: "#103B5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5024 28.0584L54.4933 34.3296C54.4907 34.6306 54.7327 34.877 55.0228 34.8756C55.1215 34.8758 55.2107 34.8495 55.2886 34.8032C55.4483 34.7083 55.5529 34.5338 55.5532 34.3305L55.5623 28.0593C55.5649 27.7584 55.3229 27.5119 55.0328 27.5133C54.7405 27.5106 54.5028 27.7535 54.5024 28.0584Z",
    fill: "#103B5D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferee);
export default __webpack_public_path__ + "static/media/Referee.a8a2ef49096a8076019ca8c7bd43b747.svg";
export { ForwardRef as ReactComponent };